import { render } from "./PurchaseSaleCard.vue?vue&type=template&id=c40147d6"
import script from "./PurchaseSaleCard.vue?vue&type=script&lang=js"
export * from "./PurchaseSaleCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__